import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=580263f8&scoped=true"
var script = {}
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=580263f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580263f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580263f8')) {
      api.createRecord('580263f8', component.options)
    } else {
      api.reload('580263f8', component.options)
    }
    module.hot.accept("./CloseIcon.vue?vue&type=template&id=580263f8&scoped=true", function () {
      api.rerender('580263f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CloseIcon.vue"
export default component.exports